// Контекстная карточка: что вокруг игрока и что с этим можно сделать.
//
// Идея, которой нет ни в SL, ни в OpenSim: не игрок ищет команды, а мир сам
// подсказывает. Стоишь на участке — карточка земли с «Купить»/«Инфо».
// Рядом твоя вещь — карточка объекта с «Забрать»/«Перекрасить». Все действия
// уходят обычными командами, сервер проверяет права как всегда — карточка
// только убирает необходимость знать команды.

export const PARCEL_HALF = 12
export const OBJECT_REACH_M = 6

const num = value => (Number.isFinite(Number(value)) ? Number(value) : 0)

// Участок под точкой, если есть.
export function parcelUnder(position, plotOrigins) {
  if (!position) return null
  const x = num(position.x ?? position[0])
  const z = num(position.z ?? position[2])
  for (let index = 0; index < (plotOrigins || []).length; index += 1) {
    const origin = plotOrigins[index]
    if (!Array.isArray(origin)) continue
    if (Math.abs(x - origin[0]) <= PARCEL_HALF && Math.abs(z - origin[2]) <= PARCEL_HALF) {
      return { index, origin }
    }
  }
  return null
}

// Ближайший объект игроков в радиусе досягаемости.
export function nearestProp(position, props) {
  if (!position) return null
  const x = num(position.x ?? position[0])
  const z = num(position.z ?? position[2])
  let best = null
  for (const prop of props || []) {
    const px = num(prop.position?.x ?? prop.position?.[0])
    const pz = num(prop.position?.z ?? prop.position?.[2])
    const meters = Math.hypot(px - x, pz - z)
    if (meters <= OBJECT_REACH_M && (!best || meters < best.meters)) {
      best = { ...prop, meters: Math.round(meters * 10) / 10 }
    }
  }
  return best
}

// Главный вход: собирает контекст из того, что видит клиент.
// Объект ближе — важнее участка: с вещью взаимодействуют чаще.
export function detectContext({ position, plotOrigins, props }) {
  const prop = nearestProp(position, props)
  if (prop) return { kind: 'object', prop }
  const parcel = parcelUnder(position, plotOrigins)
  if (parcel) return { kind: 'parcel', parcel }
  return null
}

// Действия карточки. args — команда серверу (он сам проверит права и честно
// откажет в чат), query — заготовка для палитры, когда нужен ввод.
export function contextActions(context) {
  if (!context) return []
  if (context.kind === 'object') {
    return [
      { id: 'take', label: 'Забрать', args: ['take'] },
      { id: 'sit', label: 'Сесть', args: ['sit'] },
      { id: 'color', label: 'Перекрасить', query: 'edit color ' },
      { id: 'buy', label: 'Купить', args: ['buy'] },
      { id: 'sell', label: 'Продать', query: 'sell ' },
    ]
  }
  if (context.kind === 'parcel') {
    return [
      { id: 'info', label: 'Инфо', args: ['land'] },
      { id: 'buy', label: 'Купить участок', args: ['land', 'buy'] },
      { id: 'name', label: 'Назвать', query: 'land name ' },
      { id: 'sell', label: 'Продать', query: 'land sell ' },
      { id: 'terra', label: 'Насыпь', args: ['terra', 'raise'] },
    ]
  }
  return []
}

// Заголовок карточки.
export function contextTitle(context) {
  if (!context) return null
  if (context.kind === 'object') {
    const name = context.prop.name || 'Объект'
    return `${name} · ${context.prop.meters} м`
  }
  return `Участок #${context.parcel.index}`
}
